import httpRequest from "../../servies/http";

export const SUB_USER_LOGIN_PATH = "/subUserLogin";
export const ADMIN_LOGIN_PATH = "/login";
export const SUB_USER_LANDING_PATH = "/batchDetail";
export const SUB_USER_STORAGE_KEY = "subUserAuth";
export const SUB_USER_PENDING_KEY = "subUserLoginPending";

export const SUB_USER_ROLES = {
  OPERATOR: "OPERATOR",
  AUDITOR: "AUDITOR"
};

const ROLE_MENU_KEYS = {
  OPERATOR: ["subBulkPayment", "batchDetail"],
  AUDITOR: ["batchDetail"]
};

const ROLE_ROUTE_PREFIXES = {
  OPERATOR: ["/sub/payment/bulk", SUB_USER_LANDING_PATH, "/userSettings"],
  AUDITOR: [SUB_USER_LANDING_PATH, "/userSettings"]
};

const ROLE_ID_MAP = {
  1: SUB_USER_ROLES.OPERATOR,
  2: SUB_USER_ROLES.AUDITOR
};

const ROLE_FIELDS = [
  "role",
  "roleCode",
  "roleName",
  "userRole",
  "userRoleCode",
  "accountRole",
  "accountRoleCode",
  "subUserRole",
  "subUserRoleCode",
  "permissionRole",
  "permissionRoleCode",
  "roleId",
  "userType",
  "accountType"
];

function safeJsonParse(value) {
  if (!value || value === "null" || value === "undefined") return null;
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
}

function getSessionJson(key) {
  return safeJsonParse(sessionStorage.getItem(key));
}

export function markPendingSubUserLogin() {
  sessionStorage.setItem(SUB_USER_PENDING_KEY, "true");
}

export function clearPendingSubUserLogin() {
  sessionStorage.removeItem(SUB_USER_PENDING_KEY);
}

export function isPendingSubUserLogin() {
  return sessionStorage.getItem(SUB_USER_PENDING_KEY) === "true";
}

function normalizeRole(value) {
  if (value === undefined || value === null || value === "") return "";
  const roleById = normalizeRoleId(value);
  if (roleById) return roleById;

  const text = String(value).trim();
  const upperText = text.toUpperCase();

  if (
    upperText.indexOf("AUDITOR") > -1 ||
    upperText.indexOf("AUDIT") > -1 ||
    upperText.indexOf("REVIEWER") > -1 ||
    upperText.indexOf("CHECKER") > -1 ||
    upperText.indexOf("APPROVER") > -1 ||
    text.indexOf("审核") > -1 ||
    text.indexOf("复核") > -1 ||
    text.indexOf("审批") > -1
  ) {
    return SUB_USER_ROLES.AUDITOR;
  }

  if (
    upperText.indexOf("OPERATOR") > -1 ||
    upperText.indexOf("OPERATE") > -1 ||
    upperText.indexOf("MAKER") > -1 ||
    upperText.indexOf("PAYER") > -1 ||
    upperText.indexOf("PAYMENT") > -1 ||
    text.indexOf("操作") > -1 ||
    text.indexOf("经办") > -1 ||
    text.indexOf("制单") > -1
  ) {
    return SUB_USER_ROLES.OPERATOR;
  }

  return "";
}

function normalizeRoleId(roleId) {
  const id = Number(roleId);
  if (Number.isNaN(id)) return "";
  return ROLE_ID_MAP[id] || "";
}

function hasValue(value) {
  return value !== undefined && value !== null && value !== "";
}

function collectRoleValues(source) {
  if (!source || typeof source !== "object") return [];

  const values = [];
  ROLE_FIELDS.forEach(field => {
    if (source[field]) values.push(source[field]);
  });

  ["user", "userInfo", "profile", "account", "subUser"].forEach(field => {
    if (source[field] && typeof source[field] === "object") {
      values.push.apply(values, collectRoleValues(source[field]));
    }
  });

  if (Array.isArray(source.roles)) {
    source.roles.forEach(role => {
      if (typeof role === "string") {
        values.push(role);
      } else if (role && typeof role === "object") {
        values.push(role.code, role.name, role.roleCode, role.roleName);
      }
    });
  }

  return values.filter(Boolean);
}

function getSourceRoleId(source) {
  if (!source || typeof source !== "object") return "";

  if (
    hasValue(source.roleId) ||
    hasValue(source.roleID) ||
    hasValue(source.subRoleId) ||
    hasValue(source.subUserRoleId)
  ) {
    const fields = ["roleId", "roleID", "subRoleId", "subUserRoleId"];
    const field = fields.find(key => hasValue(source[key]));
    return source[field];
  }

  const nestedFields = ["user", "userInfo", "profile", "account", "subUser"];
  for (let i = 0; i < nestedFields.length; i += 1) {
    const roleId = getSourceRoleId(source[nestedFields[i]]);
    if (hasValue(roleId)) return roleId;
  }

  return "";
}

function getOwnSourceRoleId(source) {
  if (!source || typeof source !== "object") return "";
  const fields = ["roleId", "roleID", "subRoleId", "subUserRoleId"];
  const field = fields.find(key => hasValue(source[key]));
  return field ? source[field] : "";
}

export function getSubUserRoleId(loginData, profile) {
  const profileRoleId = getOwnSourceRoleId(profile || getSessionJson("profile")) ||
    getSourceRoleId(profile || getSessionJson("profile"));
  if (hasValue(profileRoleId)) return profileRoleId;

  const loginRoleId = getSourceRoleId(loginData || getSessionJson("loginData"));
  if (hasValue(loginRoleId)) return loginRoleId;

  return "";
}

export function normalizeRoleOptionsResponse(response) {
  const source = response && response.data ? response.data : response;
  if (Array.isArray(source)) return source;
  if (source && Array.isArray(source.records)) return source.records;
  if (source && Array.isArray(source.list)) return source.list;
  return [];
}

export function resolveSubUserRoleFromRoleOptions(roleId, roleOptions) {
  if (!hasValue(roleId)) return null;

  const roleById = normalizeRoleId(roleId);
  if (!Array.isArray(roleOptions)) {
    return roleById
      ? {
        role: roleById,
        roleId,
        roleCode: "",
        roleName: ""
      }
      : null;
  }

  const matched = roleOptions.find(item => {
    if (!item || typeof item !== "object") return false;
    const ids = [item.id, item.roleId, item.value].filter(value => value !== undefined && value !== null);
    return ids.some(value => String(value) === String(roleId));
  });

  if (!matched) {
    return roleById
      ? {
        role: roleById,
        roleId,
        roleCode: "",
        roleName: ""
      }
      : null;
  }

  const matchedRoleId = hasValue(matched.id)
    ? matched.id
    : hasValue(matched.roleId)
      ? matched.roleId
      : hasValue(matched.value)
        ? matched.value
        : roleId;
  const normalizedRole =
    normalizeRole(matched.roleCode || matched.roleName || matched.name || matched.label) ||
    normalizeRoleId(matchedRoleId) ||
    roleById;

  return {
    role: normalizedRole,
    roleId: matchedRoleId,
    roleCode: matched.roleCode || "",
    roleName: matched.roleName || matched.name || matched.label || ""
  };
}

export function isMainAccountRole(loginData, profile) {
  return String(getSubUserRoleId(loginData, profile)) === "0";
}

export function getSubUserRole(loginData, profile) {
  const hasExplicitSource = Boolean(loginData || profile);
  const stored = getSessionJson(SUB_USER_STORAGE_KEY);
  if (!hasExplicitSource && stored && stored.isSubUser) {
    const storedRoleFromText = normalizeRole(
      stored.roleCode || stored.roleName || stored.rawRole
    );
    if (storedRoleFromText) return storedRoleFromText;
    if (stored.role) return normalizeRole(stored.role) || stored.role;
  }

  if (isMainAccountRole(loginData, profile)) return "";

  const roleValues = []
    .concat(collectRoleValues(loginData || getSessionJson("loginData")))
    .concat(collectRoleValues(profile || getSessionJson("profile")));

  for (let i = 0; i < roleValues.length; i += 1) {
    const role = normalizeRole(roleValues[i]);
    if (role) return role;
  }

  if (stored && stored.role) return stored.role;
  return "";
}

export function isSubUserSession(loginData, profile) {
  const sessionLoginData = loginData || getSessionJson("loginData");
  const sessionProfile = profile || getSessionJson("profile");
  const stored = getSessionJson(SUB_USER_STORAGE_KEY);

  if (stored && stored.isSubUser) return true;
  if (!sessionLoginData && !sessionProfile) return false;
  if (isMainAccountRole(sessionLoginData, sessionProfile)) return false;

  return [sessionLoginData, sessionProfile].some(source => {
    if (!source || typeof source !== "object") return false;
    const roleId = getSourceRoleId(source);
    if (hasValue(roleId) && String(roleId) !== "0") {
      return true;
    }
    if (
      source.isSubUser === true ||
      source.subUser === true ||
      source.childUser === true
    ) {
      return true;
    }

    const userType = String(
      source.userType || source.accountType || source.loginType || ""
    ).toUpperCase();
    return (
      userType.indexOf("SUB_USER") > -1 ||
      userType.indexOf("SUBUSER") > -1 ||
      userType.indexOf("CHILD_USER") > -1 ||
      userType.indexOf("CHILDUSER") > -1
    );
  });
}

export function persistSubUserAuth(loginData, profile, roleMeta, options = {}) {
  const { force = false } = options;

  if (!force && isMainAccountRole(loginData, profile)) {
    clearSubUserAuth();
    return "";
  }

  const role = (roleMeta && roleMeta.role) || getSubUserRole(loginData, profile) || SUB_USER_ROLES.AUDITOR;
  const values = []
    .concat(collectRoleValues(loginData))
    .concat(collectRoleValues(profile));
  const roleId = (roleMeta && roleMeta.roleId) || getSubUserRoleId(loginData, profile);

  sessionStorage.setItem(
    SUB_USER_STORAGE_KEY,
    JSON.stringify({
      isSubUser: true,
      role,
      roleId,
      roleCode: (roleMeta && roleMeta.roleCode) || "",
      roleName: (roleMeta && roleMeta.roleName) || "",
      rawRole: (roleMeta && (roleMeta.roleCode || roleMeta.roleName)) || values[0] || "",
      loginPath: SUB_USER_LOGIN_PATH
    })
  );
  clearPendingSubUserLogin();

  return role;
}

export function clearSubUserAuth() {
  sessionStorage.removeItem(SUB_USER_STORAGE_KEY);
}

export function buildSubUserLoginParams(form, uuid) {
  return {
    merchantNo: form.merchantNo,
    identity: form.emailPhone,
    password: form.password,
    uuid,
    captcha: form.verificationCode
  };
}

export function subUserPasswordLogin(params) {
  return httpRequest("post", "/auth/sub/login", params);
}

export function getSubUserLandingPath() {
  return SUB_USER_LANDING_PATH;
}

export function getLoginLandingPath() {
  return isSubUserSession() ? SUB_USER_LANDING_PATH : "/home";
}

export function isSubUserMenuItemVisible(menuItem) {
  if (!isSubUserSession()) return true;
  if (!menuItem || !menuItem.key) return false;

  const role = getSubUserRole() || SUB_USER_ROLES.AUDITOR;
  const menuKeys = ROLE_MENU_KEYS[role] || ROLE_MENU_KEYS.AUDITOR;

  return menuKeys.indexOf(menuItem.key) > -1;
}

export function ensureSubUserMenuItems(menuItems, t) {
  if (!isSubUserSession() || !Array.isArray(menuItems)) return;

  const subUserMenuItems = getSubUserMenuItems(t);
  menuItems.splice(0, menuItems.length, ...subUserMenuItems);
}

export function getSubUserMenuItems(t) {
  const role = getSubUserRole() || SUB_USER_ROLES.AUDITOR;
  const menuItems = [];

  if (role === SUB_USER_ROLES.OPERATOR) {
    menuItems.push({
      key: "subBulkPayment",
      label: t("LANG.page.payment.bulk_upload"),
      path: "/sub/payment/bulk"
    });
  }

  menuItems.push({
    key: "batchDetail",
    label: t("LANG.page.batchDetail.page_title_batch_detail"),
    path: SUB_USER_LANDING_PATH
  });

  return menuItems;
}

export function isSubUserAuditor() {
  return getSubUserRole() === SUB_USER_ROLES.AUDITOR;
}

export function isSubUserOperator() {
  return getSubUserRole() === SUB_USER_ROLES.OPERATOR;
}

export function canSubUserAccessPath(path) {
  if (!isSubUserSession()) return true;

  const role = getSubUserRole() || SUB_USER_ROLES.AUDITOR;
  const prefixes = ROLE_ROUTE_PREFIXES[role] || ROLE_ROUTE_PREFIXES.AUDITOR;

  return prefixes.some(
    prefix => path === prefix || path.indexOf(prefix + "/") === 0
  );
}

export function shouldSkipSubUserRouteGuard(path) {
  return [
    ADMIN_LOGIN_PATH,
    SUB_USER_LOGIN_PATH,
    "/register",
    "/resetPwd",
    "/registerFile",
    "/partnerFile",
    "/mailboxSuccess",
    "/completeAccountPhone",
    "/completeAccountEmail",
    "/completeAccountSuccess",
    "/completeAccountFailed"
  ].some(prefix => path === prefix || path.indexOf(prefix + "/") === 0);
}

export function isMockSubUserSession() {
  const loginData = getSessionJson("loginData");
  return Boolean(loginData && loginData.mock && isSubUserSession());
}

export function getSubUserBatchViewType() {
  return isSubUserAuditor() ? "auditor" : "operator";
}

export function shouldShowSubUserBatchSummary() {
  return isSubUserAuditor();
}

export function shouldShowSubUserAuditActions(row) {
  if (!isSubUserAuditor()) return false;
  return normalizeBatchStatus(row && row.status) === "PENDING";
}

export function shouldShowSubUserDetailAction() {
  // 审核员、操作员均可查看详情，不限制批次状态
  return isSubUserAuditor() || isSubUserOperator();
}

export function shouldShowSubUserOperatorActions() {
  return false;
}

export function normalizeBatchStatus(status) {
  const text = String(status || "").toUpperCase();
  if (text === "SUCCESS") return "COMPLETE";
  if (text === "NEW") return "PENDING";
  return text;
}

export function getMockSubUserBatchRows() {
  const batchNo = "MI202509191811350071000008";
  const detailSeedRows = [
    ["一般贸易", "CNH", "-140.00", "张三", "招商银行", "-140.00", "-140.00", "SUCCESS", ""],
    ["一般贸易", "HKD", "-979.43", "张三", "招商银行", "-979.43", "-979.43", "SUCCESS", ""],
    ["一般贸易", "HKD", "1000000.00", "张三", "招商银行", "1000000.00", "1000000.00", "SUCCESS", ""],
    ["一般贸易", "USD", "10000.00", "张三", "招商银行", "10000.00", "10000.00", "SUCCESS", ""],
    ["一般贸易", "CNH", "-560.00", "张三", "招商银行", "-560.00", "-560.00", "SUCCESS", ""],
    ["电商平台", "CNH", "-200.00", "张三", "招商银行", "-200.00", "-200.00", "FAILED", ""],
    ["电商平台", "CNH", "-200.00", "张三", "招商银行", "-200.00", "-200.00", "FAILED", ""],
    ["电商平台", "CNH", "-200.00", "张三", "招商银行", "-200.00", "-200.00", "FAILED", ""],
    ["电商平台", "CNH", "-200.00", "张三", "招商银行", "-200.00", "-200.00", "FAILED", ""]
  ];
  const detailRows = Array.from({ length: 10 }).flatMap((_, pageIndex) =>
    detailSeedRows.map((item, index) => ({
      id: batchNo + "-detail-" + (pageIndex * detailSeedRows.length + index + 1),
      bizTypeLabel: item[0],
      paymentNo: batchNo,
      paymentTime: "2026-02-02 17:37:13",
      amount: item[2],
      currency: item[1],
      payerName: item[3],
      receiveBank: item[4],
      feeAmount: item[5],
      feeCurrency: item[1],
      receivedAmount: item[6],
      receivedCurrency: item[1],
      status: item[7],
      remark: item[8]
    }))
  );
  const baseRows = [
    ["Test", "176.76", "HKD", "COMPLETE"],
    ["Store Name...", "979.43", "HKD", "COMPLETE"],
    ["Store Name...", "1000000.00", "HKD", "COMPLETE"],
    ["Store Name...", "10000.00", "USD", "COMPLETE"],
    ["Store Name...", "560.00", "CNH", "PROCESSING"],
    ["Store Name...", "200.00", "CNH", "PROCESSING"],
    ["Store Name...", "200.00", "CNH", "PROCESSING"],
    ["Store Name...", "200.00", "CNH", "PENDING"],
    ["Store Name...", "200.00", "CNH", "EXPIRED"]
  ];

  return baseRows.map((row, index) => ({
    id: index + 1,
    batchNo,
    createTime: "2026-02-02 17:37:13",
    fileName: index === 0 ? "" : "BatchPayout...",
    fileCode: index === 0 ? "" : "mock-file-" + (index + 1),
    shopName: row[0],
    amount: row[1],
    currency: row[2],
    totalNum: 2,
    successNum: 0,
    failNum: 0,
    status: row[3],
    errorMessage: "",
    detailList: detailRows,
    detailTotal: detailRows.length,
    resultFileCode: "",
    canInputCaptcha: false,
    canResendCaptcha: false
  }));
}

export function getMockSubUserBatchSummary() {
  return [
    { currency: "USD", flag: "🇺🇸", b2c: "100.00", b2b: "100.00", total: "100.00" },
    { currency: "HKD", flag: "🇭🇰", b2c: "100.00", b2b: "100.00", total: "100.00" },
    { currency: "CNH", flag: "🇨🇳", b2c: "100.00", b2b: "100.00", total: "100.00" },
    { currency: "HKD", flag: "🇭🇰", b2c: "100.00", b2b: "100.00", total: "100.00" },
    { currency: "CNH", flag: "🇨🇳", b2c: "100.00", b2b: "100.00", total: "100.00" }
  ];
}
